export default __webpack_public_path__ + "static/media/pro-1.3da923bc.jpg";